import React, { createContext, useContext, useEffect, useState } from "react";

const LocationContext = createContext(null);
export const useLocation = () => useContext(LocationContext);

const EMPTY = { lat: null, lng: null, address: "", city: "", state: "", pincode: "", set: false };

export function LocationProvider({ children }) {
  const [location, setLocation] = useState(() => {
    try { return JSON.parse(localStorage.getItem("gf_loc")) || EMPTY; }
    catch { return EMPTY; }
  });
  const [detecting, setDetecting] = useState(false);

  useEffect(() => { localStorage.setItem("gf_loc", JSON.stringify(location)); }, [location]);

  const reverseGeocode = async (lat, lng) => {
    const r = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=16&addressdetails=1`,
      { headers: { "Accept-Language": "en" } });
    const d = await r.json();
    const a = d.address || {};
    return {
      lat, lng,
      address: d.display_name?.split(",").slice(0, 3).join(", ") || "Selected location",
      city: a.city || a.town || a.village || a.suburb || a.state_district || "",
      state: a.state || "", pincode: a.postcode || "", set: true,
    };
  };

  const detectCurrent = () => new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("Geolocation not supported"));
    setDetecting(true);
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        try {
          const loc = await reverseGeocode(pos.coords.latitude, pos.coords.longitude);
          setLocation(loc); setDetecting(false); resolve(loc);
        } catch (e) { setDetecting(false); reject(e); }
      },
      (err) => { setDetecting(false); reject(err); },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  });

  const searchAddress = async (query) => {
    const r = await fetch(`https://nominatim.openstreetmap.org/search?format=json&countrycodes=in&limit=6&addressdetails=1&q=${encodeURIComponent(query)}`,
      { headers: { "Accept-Language": "en" } });
    const d = await r.json();
    return d.map((x) => ({
      lat: parseFloat(x.lat), lng: parseFloat(x.lon),
      address: x.display_name.split(",").slice(0, 3).join(", "),
      full: x.display_name,
      city: x.address?.city || x.address?.town || x.address?.village || "",
      state: x.address?.state || "", pincode: x.address?.postcode || "",
    }));
  };

  const hasLocation = !!(location && location.set);

  return (
    <LocationContext.Provider value={{ location, setLocation, detecting, detectCurrent, searchAddress, reverseGeocode, hasLocation }}>
      {children}
    </LocationContext.Provider>
  );
}
